import { useState } from 'react';
import { Tab } from '@headlessui/react';
import moment from 'moment';
import useStorage from '../../../utils/hooks/useStorage';
import Link from 'next/link';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Tabs({ blogs, categories }) {
  const blogCategories = ['All Stories', categories.map((category) => category.attributes.name)];
  let [tabs] = useState({
    'All Stories': blogs,
    'Program Info': blogs.filter(
      (category) => category.attributes.category?.data?.attributes?.name === 'Program Info'
    ),
    'Careers in Tech': blogs.filter(
      (category) => category.attributes.category?.data?.attributes?.name === 'Careers in Tech'
    ),
    'Data Science': blogs.filter(
      (category) => category.attributes.category?.data?.attributes?.name === 'Data Science'
    ),
    'Software Engineering with AI': blogs.filter(
      (category) =>
        category.attributes.category?.data?.attributes?.name === 'Software Engineering with AI'
    ),
    Blockchain: blogs.filter(
      (category) => category.attributes.category?.data?.attributes?.name === 'Blockchain'
    ),
  });

  return (
    <div className="w-full py-16 sm:px-0 lg:px-2">
      <Tab.Group>
        <Tab.List className="mx-0.5 flex flex-wrap gap-2">
          {blogCategories.flat().map((category) => (
            <Tab
              key={category}
              className={({ selected }) =>
                classNames(
                  'text-blue-700  rounded-lg py-2.5 px-4 font-satoshi-medium text-xs font-medium  leading-5 md:text-base',
                  selected ? 'bg-red text-white shadow' : 'bg-yellow-light'
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>

        <Tab.Panels className="mt-2">
          {Object.values(tabs).map((blogs, idx) => (
            <Tab.Panel key={idx} className={classNames('rounded-xl bg-white lg:p-3')}>
              <div className="mt-8 grid grid-flow-row gap-8 lg:grid-cols-2">
                {blogs.map((blog, idx) => (
                  <BlogCard key={idx} {...blog} />
                ))}
              </div>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}

export const BlogCard = (props) => {
  const { getItem } = useStorage();
  const currentUtm = getItem('utm') && JSON.parse(getItem('utm'));
  // set query string for redirect
  let queryString = '';
  for (const property in currentUtm) {
    queryString += `&${property}=${currentUtm[property]}`;
  }
  const blogDate = moment(props.attributes?.publishedAt).format('MMMM Do YYYY');
  return (
    <Link
      href={
        queryString
          ? `/blogs/${props?.attributes?.slug}?${queryString}`
          : `/blogs/${props?.attributes?.slug}`
      }
      as={
        queryString
          ? `/blogs/${props?.attributes?.slug}?${queryString}`
          : `/blogs/${props?.attributes?.slug}`
      }
      passHref
      legacyBehavior
    >
      <a className="tapHighlight mx-auto flex max-w-xs cursor-pointer flex-col justify-center rounded-lg shadow-md lg:max-w-sm lg:hover:shadow-lg">
        <div>
          <img
            className="h-[250px] w-full rounded-t-lg"
            src={props?.attributes?.image?.data?.attributes?.url}
            alt=""
          />
        </div>

        <div className="relative h-fit p-6">
          {props.attributes?.category?.data?.attributes.name && (
            <span className="whitespace-nowrap rounded bg-[#CC0000] py-1 px-2.5 text-center align-baseline font-satoshi-medium text-xs font-medium  leading-none text-white lg:text-sm">
              {props.attributes?.category?.data?.attributes.name}
            </span>
          )}
          <span className="float-right whitespace-nowrap rounded py-1.5 px-2.5 text-center align-baseline font-satoshi-medium text-xs leading-none text-black lg:text-sm">
            {blogDate && blogDate}
          </span>

          <h2 className="mt-4 font-satoshi-bold text-xl leading-7">{props?.attributes?.title}</h2>
          <p className="my-4 !font-satoshi-medium text-[20px] leading-5 text-black lg:text-base lg:leading-6">
            {props?.attributes?.description?.slice(0, 80).trim()}
            <span className="font-satoshi-bold text-[20px] font-bold  leading-5 lg:text-base lg:leading-6">
              {props?.attributes?.description?.length > 80 && '...Read More'}
            </span>
          </p>
          {/* <a className=' inline-block px-6 py-2.5 bg-blue-600 text-black font-satoshi-medium font-medium  text-xs leading-tight uppercase rounded shadow-md'>
            Read More
          </a> */}
        </div>
      </a>
    </Link>
  );
};
